.fontStyle {
  font-style: italic !important;
}

.profilePicture {
  border-radius: 50% !important;
  overflow: hidden !important;
  width: 60px !important;
  height: 60px !important;
  border-color: blue !important;
  border-style: solid !important;
  border-width: 0.5px !important;
}

.textRight {
  text-align: right !important;
}


.errorPlaceHolderStyle {
  color: var(--mantine-color-error) !important;
}

.errorLabelStyle {
  color: var(--mantine-color-error) !important;
  font-size: calc(var(--input-error-size, calc(var(--mantine-font-size-sm) - 0.125rem)) * var(--mantine-scale)) !important;
}

.phoneNumberInput {
  font-size: var(--input-fz, var(--input-fz, var(--mantine-font-size-sm))) !important;
  /* font-family: var(--input-font-family, var(--mantine-font-family)) !important; */
  color: var(--input-color) !important;
  font-family: system-ui;
}

.phoneNumberInputDark {
  font-size: var(--input-fz, var(--input-fz, var(--mantine-font-size-sm))) !important;
  /* font-family: var(--input-font-family, var(--mantine-font-family)) !important; */
  color: var(--input-color) !important;
}

.phoneNumberInputError {
  border-color: var(--mantine-color-error) !important;
}


.asteriskStyles {
  font-size: 10px !important;
  color: var(--input-asterisk-color, var(--mantine-color-error));
  margin-left: 4px !important;
}

.tableFirstColumn {
  text-transform: capitalize !important;
  font-weight: 900 !important;
  font-size: 14px !important;
  line-height: 19px !important;
}

.workItemLevelColumn {
  text-transform: capitalize !important;
  font-weight: 800 !important;
  line-height: 19px !important;
}

.tableRemainingColumns {
  font-size: 12px !important;
  /* text-transform: uppercase !important; */
  font-weight: 700 !important;
  color: #334155 !important;
  font-family: 'Inter' !important;
}

.tableRemainingDisableColumns {
  font-size: 12px !important;
  /* text-transform: uppercase !important; */
  font-weight: 700 !important;
  color: #94A3B8 !important;
  line-height: 19px !important;
}

.tableDateFormat {
  font-size: 11px !important;
  font-weight: 700 !important;
  color: #334155 !important;
  font-family: 'Inter' !important;
}

.tableDateFormatOne {
  font-size: 11px !important;
  font-weight: 700 !important;
  color: #94A3B8 !important;
  line-height: 19px !important;
}

.labelStyle {
  font-weight: 900 !important;
  color: rgb(148 163 184) !important;
  font-size: 9.5px !important;
  letter-spacing: 0.15em !important;
  text-transform: uppercase !important;
  padding-left: 2px !important;
  font-family: Inter !important;
  /* when change the labelStles we will change the phone number styles */
}

.radioLabelStyle {
  font-weight: 900 !important;
  color: rgb(148 163 184) !important;
  font-size: 9.5px !important;
  letter-spacing: 0.15em !important;
  text-transform: uppercase !important;
  padding-left: 2px !important;
}

.ActiveRadioLabelStyle {
  font-weight: 900 !important;
  color: #0f172a !important;
  font-size: 9.5px !important;
  letter-spacing: 0.15em !important;
  /* letter-spacing: 0.1em !important;*/
  text-transform: uppercase !important;
  padding-left: 5px !important;
}

.inputStyle {
  color: #0f172a !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  padding-top: 1.2rem !important;
  padding-bottom: 1.2rem !important;
  background-color: #f8fafc !important;
  border-radius: .75rem !important;
  border: .75px solid #e2e8f0 !important;
  transition: all 0.2s ease !important;
}

.inputNativeSelectStyle {
  color: #0f172a !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  background-color: #f8fafc !important;
  border-radius: .75rem !important;
  border: .75px solid #e2e8f0 !important;
  transition: all 0.2s ease !important;
}

.inputMultiStyle {
  color: #0f172a !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  background-color: #f8fafc !important;
  border-radius: .75rem !important;
  border: .75px solid #e2e8f0 !important;
  transition: all 0.2s ease !important;
}

.inputStyle:not([readonly]):focus:not([aria-invalid="true"]) {
  border: 1px solid var(--mantine-color-default_Blue-6) !important;
  box-shadow: 0 0 0 3px rgba(34, 139, 230, 0.15) !important;
}

.inputStyle[aria-invalid="true"] {
  border: 1px solid var(--mantine-color-red-6) !important;
  box-shadow: none !important;
}

.inputStyle[aria-invalid="true"]:focus {
  border: 1px solid var(--mantine-color-red-6) !important;
  box-shadow: 0 0 0 3px rgba(250, 82, 82, 0.15) !important;
}

.inputStyle[readonly]:not([aria-invalid="true"]) {
  cursor: default !important;
  box-shadow: none !important;
}


/* Multi-Select */
.inputMultiStyle:not([readonly]):focus:not([aria-invalid="true"]) {
  border: 1px solid var(--mantine-color-default_Blue-6) !important;
  box-shadow: 0 0 0 3px rgba(34, 139, 230, 0.15) !important;
}

.inputMultiStyle[aria-invalid="true"] {
  border: 1px solid var(--mantine-color-red-6) !important;
  box-shadow: none !important;
}

.inputMultiStyle[aria-invalid="true"]:focus {
  border: 1px solid var(--mantine-color-red-6) !important;
  box-shadow: 0 0 0 3px rgba(250, 82, 82, 0.15) !important;
}

.inputMultiStyle[readonly]:not([aria-invalid="true"]) {
  cursor: default !important;
  box-shadow: none !important;
}

.phoneInputStyle {
  color: #0f172a !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  padding-top: 1.2rem !important;
  padding-bottom: 1.2rem !important;
  background-color: #f8fafc !important;
  border-radius: .75rem !important;
  border: .75px solid #e2e8f0 !important;
}

.phoneInputStyle:hover,
.phoneInputStyle:focus {
  border-right: none !important;
}


/* Base */
.phoneNumberWrapper :global(input) {
  color: #0f172a !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  padding-top: 1.2rem !important;
  padding-bottom: 1.2rem !important;
  background-color: #f8fafc !important;
  border-radius: .75rem !important;
  border: .75px solid #e2e8f0 !important;
  transition: all 0.2s ease !important;
}

.dateInputStyle {
  color: #0f172a !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  padding-top: .5rem !important;
  padding-bottom: .5rem !important;
  background-color: #f8fafc !important;
  border-radius: .75rem !important;
  border: .75px solid #e2e8f0 !important;
  transition: all 0.2s ease !important;
}

/* Focus (editable only) */
.phoneNumberWrapper :global(input:not([readonly]):focus) {
  border-color: var(--mantine-color-default_Blue-6) !important;
  box-shadow: 0 0 0 3px rgba(34, 139, 230, 0.15) !important;
}

/* Error */
.phoneError :global(input) {
  border-color: var(--mantine-color-red-6) !important;
  border-width: 1px !important;
  border-style: solid !important;
}

/* Error + Focus */
.phoneError :global(input:focus) {
  border-color: var(--mantine-color-red-6) !important;
  box-shadow: 0 0 0 3px rgba(250, 82, 82, 0.15) !important;
}


.buttonStyle,
.buttonStyle:hover,
.buttonStyle:focus {
  background-color: #005ee6 !important;
  line-height: 20px !important;
  padding-top: 1.2rem !important;
  padding-bottom: 1.2rem !important;
  border-radius: .75rem !important;
  z-index: 999 !important;
}



.dateLabelText {
  color: #979494 !important;
  font-size: 10px !important;
  font-weight: 900 !important;
}

.buttonLabel {
  color: #ffffff !important;
  font-weight: 500 !important;
  font-size: 14px !important;
}

.cursor {
  cursor: pointer !important;
}

.breadcrumbsSpan {
  color: var(--mantine-color-error) !important;
  font-weight: 500 !important;
  font-size: var(--input-error-size, calc(var(--mantine-font-size-sm) - calc(0.125rem* var(--mantine-scale)))) !important;
}

:root {
  --blue-filled-color: var(--mantine-color-blue-filled) !important;
}

.elementWithColorIcons {
  color: var(--blue-filled-color) !important;
}

.clickableColor {
  color: var(--mantine-color-blue-outline) !important;
  cursor: pointer !important;
}


.accordionHighlightedColor {
  cursor: pointer !important;
  background-color: lightblue !important;
}


.activeTab {
  color: var(--blue-filled-color) !important;
}

.subHeading {
  color: '';
}

.multiSelectContainer {
  --rmsc-main: var(--input-bg) !important;
  --rmsc-hover: var(--input-bg) !important;
  --rmsc-selected: var(--input-bg) !important;
  --rmsc-gray: var(--input-bg) !important;
  --rmsc-bg: var(--input-bg) !important;
}

/* manage policy table */

/* .MRT_TableHeadCellResizeHandle-module_root__paufe {
  background: transparent !important;
} */

.item {
  cursor: pointer;
  transition: box-shadow 150ms ease, transform 100ms ease;
  position: relative;
  border: 1px solid rgb(241 245 249 / var(--tw-border-opacity, 1));

  .cardActions {
    position: absolute;
    top: 8px;
    right: 8px;
    opacity: 0;
    transition: opacity 150ms ease;
    z-index: 10;
    border: 1px solid rgb(94, 95, 97);
  }

  &:hover {
    box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.3);
    transform: translateY(-2px);
    border: 1px solid rgba(222, 222, 223, 1);

    .cardActions {
      opacity: 1;
    }
  }
}

.item {
  text-align: left;
  transition: 'all 200ms ease';
  border: '1px solid rgb(241 245 249)';
  box-shadow: '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04)';
}

.item:hover {
  box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.3);
  border: 0.5px solid rgba(167, 187, 214, 1);
}

.card-table {
  border-collapse: separate;
  border-spacing: 0 12px;
  background: transparent;
  vertical-align: middle;
  align-items: center;
}



/* .mantine-Table-root td,
.mantine-Table-root th { border-bottom: none; border: none; }

:global(.m_b2404537) > :where(tr):where([data-with-row-border]),
:global(.m_b2404537) > :where(tr):where([data-with-row-border]) td,
:global(.m_b2404537) > :where(tr):where([data-with-row-border]) th {
  border-bottom: none !important;
  box-shadow: none !important;
  background-color: none !important;
  --paper-border-color: transparent !important;
}
:global([data-mantine-color-scheme='light'] .m_1b7284a3),
:global([data-mantine-color-scheme='light'] .m_e615b15f) {
  --paper-border-color: transparent !important;
} */

.actionIcons {
  opacity: 0;
}

.viewRecord {
  display: block !important;
  cursor: pointer !important;
}

.viewRecord:hover .actionIcons {
  opacity: 1;
}

.eventBoxCss {
  background-color: '#0f172a' !important;
  border-radius: 30 !important;
  color: 'white' !important;
  font-size: 14 !important;
  font-weight: 500 !important;
  word-break: break-all !important;
}

.eventValueDiv {
  background-color: #0f172a !important;
  border-radius: 2rem !important;
  font-size: 11px !important;
  padding: 1.5rem !important;

}

.eventBoxCss Text {
  word-break: break-all !important;
  overflow-wrap: anywhere !important;
}

.eventValueDiv Text {
  word-break: break-all !important;
  overflow-wrap: anywhere !important;
}

.packageHeading {
  color: #94a3b8 !important;
  font-size: .75rem !important;
  text-transform: uppercase !important;
  letter-spacing: .1em !important;
}

@media screen and (max-width: 426px) {
  .organizationContainer {
    padding: 0px !important;
  }
}
